import React, { createContext, useContext, useState } from 'react';

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([]);

    const showAlert = (message, type = 'success', isPersistent = false) => {
        const newAlert = {
            id: Date.now(),
            message,
            type,
            isPersistent
        };

        setAlerts(prev => [...prev, newAlert]);

        if (!isPersistent) {
            // Auto-clear non-persistent alerts after 5 seconds
            setTimeout(() => {
                clearAlert(newAlert.id);
            }, 5000);
        }
    };

    const clearAlert = (alertId) => {
        setAlerts(prev => prev.filter(alert => alert.id !== alertId));
    };

    const clearAllAlerts = () => {
        setAlerts([]);
    };

    return (
        <AlertContext.Provider value={{ alerts, showAlert, clearAlert, clearAllAlerts }}>
            {children}
        </AlertContext.Provider>
    );
};

export const useAlert = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlert must be used within an AlertProvider');
    }
    return context;
}; 